import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { HeartHandshake } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';

/**
 * Mobile sticky bottom bar (Call + Request Care) for public marketing pages.
 * Hidden for authenticated users and on the /auth screen.
 */
export const PublicCtaBar = () => {
  const { user } = useAuth();
  const { pathname } = useLocation();

  if (user) return null;
  if (pathname.startsWith('/auth')) return null;

  return (
    <div
      className="md:hidden fixed bottom-0 inset-x-0 z-40 border-t border-cn-border bg-white/95 backdrop-blur shadow-[0_-6px_20px_rgba(0,0,0,0.06)]"
      data-testid="mobile-cta-bar"
    >
      <Link
        to="/auth"
        className="flex items-center justify-center gap-2 py-3.5 bg-cn-accent text-white font-semibold active:bg-cn-accent-hover"
        data-testid="mobile-cta-get-started"
      >
        <HeartHandshake className="w-4 h-4" /> Get started
      </Link>
    </div>
  );
};

export default PublicCtaBar;
